module.exports = `${require.publicPath}204.8b73d420.png`;